/**
 * @author Fernando FH
 * @company Erillam Healthcare
 * @version 1.0
 */

 import ServicePath from "@/core/ServicePath"
 import { MainRequest } from "@/core/request";

 export default class SepomexRequest extends MainRequest{

  
    static listAllByPostalCode(data) {
        return this.postSEC(ServicePath.SEPOMEX_ALL_BY_CP, data);
    }
     

 }